import { useEffect } from 'react';

import { forceLogout } from 'services/config';
import { hasRecentActivity, IDLE_LIMIT_MS } from 'util/userActivity';

const ONE_MINUTE = 60000;

export default function useIdleLogout() {
  useEffect(() => {
    const intervalId = setInterval(() => {
      if (!hasRecentActivity(IDLE_LIMIT_MS)) {
        forceLogout();
      }
    }, ONE_MINUTE);

    return () => clearInterval(intervalId);
  }, []);
}
